import React, { useEffect, useRef } from 'react';

interface UnitWhiteLabelAccountCardProps {
  //accountId: string;
  customerToken: string;
  theme?: string;
  language?: string;
  hideActionsMenuButton?: boolean;
  hideSelectionMenuButton?: boolean;
  hideAccountDetails?: boolean;
  hideAccountButtons?: boolean;
  hideAccountStatus?: boolean;
  hideAccountCtaBanner?: boolean;
  accountStatusPosition?: string;
  onLoadComplete?: () => void;
}

const UnitWhiteLabelAccountCard: React.FC<UnitWhiteLabelAccountCardProps> = ({
  //accountId,
  customerToken, //= "v2.public.eyJyb2xlIjoiY3VzdG9tZXIiLCJyb2xlcyI6WyJjdXN0b21lciJdLCJ1c2VySWQiOm51bGwsInN1YiI6ImN1c3RvbWVyLzI5OTU0MjkvbWFoZXNoQG1hcnNtYXJrZXRzLmNvbSIsImV4cCI6IjIwMjUtMDgtMjBUMDc6MTk6MzkuNzI0WiIsImp0aSI6ImN1c3RvbWVyLTI5OTU0MjktMTc1NTY3NDM3OTcyNC05MzcyNDkzMS03MjE3LTRlODQtYjI2YS1mY2U3YTM4N2U0NDkiLCJvcmdJZCI6IjY1MzAiLCJzY29wZSI6ImFwcGxpY2F0aW9ucyBjdXN0b21lcnMgYWNjb3VudHMgY2FyZHMgdHJhbnNhY3Rpb25zIHN0YXRlbWVudHMgcGF5bWVudHMgcmVwYXltZW50cyBjb3VudGVycGFydGllcyBhdXRob3JpemF0aW9ucyByZXdhcmRzIHNldHRsZW1lbnRzIGxpbmtlZC1hY2NvdW50cyBhdXRob3JpemF0aW9uLXJlcXVlc3RzIGNoZWNrLWRlcG9zaXRzIHJlY2VpdmVkLXBheW1lbnRzIGNoZWNrLXBheW1lbnRzIGN1c3RvbWVyLXRva2VuLXdyaXRlIiwiY3VzdG9tZXJJZCI6IjI5OTU0MjkiLCJ1c2VyVHlwZSI6ImN1c3RvbWVyIiwidXBncmFkYWJsZVNjb3BlIjoiY3VzdG9tZXJzLXdyaXRlIGFjY291bnRzLXdyaXRlIGNhcmRzLXdyaXRlIGNhcmRzLXNlbnNpdGl2ZSBjYXJkcy1zZW5zaXRpdmUtd3JpdGUgdHJhbnNhY3Rpb25zLXdyaXRlIHBheW1lbnRzLXdyaXRlIHJlcGF5bWVudHMtd3JpdGUgcGF5bWVudHMtd3JpdGUtY291bnRlcnBhcnR5IHBheW1lbnRzLXdyaXRlLWxpbmtlZC1hY2NvdW50IHBheW1lbnRzLXdyaXRlLWFjaC1kZWJpdCBjb3VudGVycGFydGllcy13cml0ZSBsaW5rZWQtYWNjb3VudHMtd3JpdGUgYXV0aG9yaXphdGlvbi1yZXF1ZXN0cy13cml0ZSBjaGVjay1kZXBvc2l0cy13cml0ZSByZWNlaXZlZC1wYXltZW50cy13cml0ZSBjaGVjay1wYXltZW50cy13cml0ZSJ9UFDCbvXqhwEcN6nTZupOtw76jaL2msdGPKCors16wscWQKkYL4_3eLm-rN4SaBNtxmwxPHflSUOB7pnu0Mj0AQ",
  theme = "",
  language = "",
  hideActionsMenuButton = true,
  hideSelectionMenuButton = true,
  hideAccountDetails = true,
  hideAccountButtons = true,
  hideAccountStatus = true,
  hideAccountCtaBanner = true,
  accountStatusPosition = "start",
  
  onLoadComplete
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const scriptId = 'unit-wl-script';
    const env = process.env.REACT_APP_FIREBASE_ENV;
    let scriptUrl = 'https://ui.s.unit.sh/release/latest/components-extended.js';
    if (env === 'production') {
      scriptUrl = 'https://ui.unit.co/release/latest/components-extended.js';
    }
    // Load SDK script once globally
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = scriptUrl;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  useEffect(() => {
    // Validate customer token before proceeding
    if (!customerToken || customerToken === 'undefined' || customerToken.trim() === '') {
      if (containerRef.current) {
        containerRef.current.innerHTML = '<div class="text-center text-gray-500 p-4">Invalid token - please refresh</div>';
      }
      return;
    }

    const el = document.createElement('unit-elements-account');
    //el.setAttribute('account-id', accountId);
    if (customerToken) el.setAttribute('customer-token', customerToken);
    if (theme) el.setAttribute('theme', theme);
    if (language) el.setAttribute('language', language);
    el.setAttribute('hide-actions-menu-button', hideActionsMenuButton.toString());
    el.setAttribute('hide-selection-menu-button', hideSelectionMenuButton.toString());
    el.setAttribute('hide-account-details', hideAccountDetails.toString());
    el.setAttribute('hide-account-buttons', hideAccountButtons.toString());
    el.setAttribute('hide-account-status', hideAccountStatus.toString());
    el.setAttribute('hide-account-cta-banner', hideAccountCtaBanner.toString());
    el.setAttribute('account-status-position', accountStatusPosition);
    
    // Add error event listener
    el.addEventListener('unitOnLoad', function (e: Event) {
      try {
        const event = e as CustomEvent;
        if (event.detail?.errors) {
          console.error('❌ UnitWhiteLabelAccountCard: Unit.co error:', event.detail.errors);
          
          const errors = Array.isArray(event.detail.errors) ? event.detail.errors : [event.detail.errors];
          errors.forEach((error: any, index: number) => {
            console.error(`❌ UnitWhiteLabelAccountCard Error ${index + 1}:`, {
              error,
              status: error?.status,
              message: error?.message,
              detail: error?.detail,
              timestamp: new Date().toISOString()
            });
          });
          
          // Handle 500 errors
          if (errors[0]?.status === '500' || errors[0]?.status === 500) {
            console.error('🚨 UnitWhiteLabelAccountCard: Server error (500)');
            
            if (containerRef.current) {
              containerRef.current.innerHTML = `
                <div class="text-center p-4">
                  <p class="text-red-600 text-sm mb-2">Unable to load account information</p>
                  <p class="text-gray-500 text-xs mb-3">The banking service is temporarily unavailable.</p>
                  <button 
                    onclick="window.location.reload()" 
                    class="px-3 py-1 bg-blue-600 text-white text-xs rounded hover:bg-blue-700 transition-colors"
                  >
                    Reload
                  </button>
                </div>
              `;
            }
            
            // Dispatch error event for tracking
            window.dispatchEvent(new CustomEvent('unitcoPluginError', {
              detail: {
                type: 'account_card_error',
                status: 500,
                errors: errors,
                timestamp: new Date().toISOString()
              }
            }));
          }
        }
      } catch (err) {
        console.error('❌ UnitWhiteLabelAccountCard: Error in unitOnLoad handler:', err);
      }
    });
    
    // Add general error event listener
    el.addEventListener('error', function (e: Event) {
      console.error('❌ UnitWhiteLabelAccountCard: Element error event:', e);
      window.dispatchEvent(new CustomEvent('unitcoPluginError', {
        detail: {
          type: 'account_card_element_error',
          event: e,
          timestamp: new Date().toISOString()
        }
      }));
    });
    
    // Inject custom element into container
    if (containerRef.current) {
      containerRef.current.innerHTML = '';
      containerRef.current.appendChild(el);

      // Call onLoadComplete immediately after element is added
      if (onLoadComplete) {
        setTimeout(() => onLoadComplete(), 100);
      }
    }
    // Function to remove header section
    const removeHeaderSection = (appElement: Element) => {
      if (!appElement.shadowRoot) return;
      
      try {
        // Try to find and hide/remove header elements
        const headerSelectors = [
          'header',
          '.header',
          '[data-testid*="header"]',
          '[class*="header"]',
          '[class*="Header"]',
          '.account-header',
          '.balance-header'
        ];
        
        headerSelectors.forEach(selector => {
          const headerElements = appElement.shadowRoot!.querySelectorAll(selector);
          headerElements.forEach(element => {
            (element as HTMLElement).style.display = 'none';
          });
        });

        // Also try to remove any top-level elements that might be headers
        const allElements = appElement.shadowRoot!.querySelectorAll('*');
        allElements.forEach(element => {
          const elementStyle = window.getComputedStyle(element);
          const elementText = element.textContent?.toLowerCase() || '';
          
          // Check if element looks like a header (has header-like text or styling)
          if (
            elementText.includes('account') && 
            elementText.includes('balance') ||
            elementStyle.fontWeight === 'bold' && 
            elementStyle.fontSize && 
            parseInt(elementStyle.fontSize) > 16
          ) {
            (element as HTMLElement).style.display = 'none';
          }
        });
      } catch (error) {
        console.error('Could not remove header section:', error);
      }
    };

    function addStyle() {
      const observer = new MutationObserver(() => {
        document
          .querySelectorAll(".unit-detailsContainer-0-9-16 .content .balanceAndHoldContainer .balanceContainer .decimal")
          .forEach((el: Element) => {
            console.log('Style added', el, el instanceof HTMLElement);
            if (el instanceof HTMLElement) 
              {
                el.style.setProperty('font-size', 'calc(24 / var(--common-root-font-size, 16))', 'important');
              }
          });
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
      




      // const style = document.createElement("style");
      // style.textContent = `
      //   .unit-detailsContainer-0-9-16 .content .balanceAndHoldContainer .balanceContainer .decimal {
      //     font-size: calc(24 / var(--common-root-font-size, 16)) !important;
      //   }
      // `;
      // document.head.appendChild(style);
      // console.log('Style added', style, document.head);
    }


    const styleObserver = new MutationObserver(() => {
      const account = document.querySelector('unit-elements-account');
      if (!account?.shadowRoot) return;
      account.shadowRoot.querySelectorAll('.decimal').forEach((el: Element) => {
        if (el instanceof HTMLElement) el.style.setProperty('font-size', 'calc(24 / var(--common-root-font-size, 16))', 'important');
      });
    });
    styleObserver.observe(document.body, { childList: true, subtree: true });

    // Cleanup
    return () => {
      styleObserver.disconnect();
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, [customerToken, theme, language, hideActionsMenuButton, hideSelectionMenuButton, hideAccountDetails, hideAccountButtons, hideAccountStatus, hideAccountCtaBanner, onLoadComplete]);

  return (
    <div
      ref={containerRef}
    />
  );
  
};

export default UnitWhiteLabelAccountCard;
